import { Column } from '@simplywallst/ui-core';
import DeprecatedKeyMetric from '@/components/DeprecatedKeyMetric';
import PositiveNegativeValue from '@/components/PositiveNegativeValue';
import { Title, Currency, ReturnsSummaryWrapper } from './styled';

export interface ReturnsSummaryProps {
  isWatchlist: boolean;
  portfolioWithNoTransactions: boolean;
  totalReturn: number;
  totalReturnFormatted: string;
  capitalGainFormatted: string;
  currencyGainFormatted: string;
  currencyReturn: number | null;
  currencyReturnFormatted: string;
  dividendReturn: number;
  dividendReturnFormatted: string;
  dividendGainFormatted: string;
  totalDividendReturn: number;
  totalDividendReturnFormatted: string;
  totalGainFormatted: string;
  hasHoldingsInDifferentCurrencies: boolean;
}

const ReturnsSummary = ({
  isWatchlist,
  portfolioWithNoTransactions,
  totalReturn,
  totalReturnFormatted,
  capitalGainFormatted,
  currencyReturn,
  currencyReturnFormatted,
  currencyGainFormatted,
  dividendReturn,
  dividendReturnFormatted,
  dividendGainFormatted,
  totalDividendReturn,
  totalDividendReturnFormatted,
  totalGainFormatted,
  hasHoldingsInDifferentCurrencies,
}: ReturnsSummaryProps) => (
  <>
    <Title>
      {isWatchlist || portfolioWithNoTransactions
        ? `1 Year Returns`
        : `Returns since Inception`}
    </Title>
    <ReturnsSummaryWrapper>
      <Column col={12} colSm={3}>
        <DeprecatedKeyMetric
          title="Capital Gain"
          size="large"
          metric={
            <>
              <PositiveNegativeValue value={totalReturn / 100}>
                {totalReturnFormatted}
              </PositiveNegativeValue>
            </>
          }
        />
        {!isWatchlist && (
          <Currency>
            <DeprecatedKeyMetric size="large" metric={capitalGainFormatted} />
          </Currency>
        )}
      </Column>
      <Column col={12} colSm={3}>
        <DeprecatedKeyMetric
          title="Dividend Income"
          size="large"
          metric={
            <>
              <PositiveNegativeValue value={dividendReturn / 100}>
                {dividendReturnFormatted}
              </PositiveNegativeValue>
            </>
          }
        />
        {!isWatchlist && (
          <Currency>
            <DeprecatedKeyMetric size="large" metric={dividendGainFormatted} />
          </Currency>
        )}
      </Column>
      {hasHoldingsInDifferentCurrencies && (
        <Column col={12} colSm={3}>
          <DeprecatedKeyMetric
            title="Currency Gain"
            size="large"
            metric={
              <>
                <PositiveNegativeValue value={currencyReturn}>
                  {currencyReturnFormatted}
                </PositiveNegativeValue>
              </>
            }
          />
          {!isWatchlist && (
            <Currency>
              <DeprecatedKeyMetric
                size="large"
                metric={currencyGainFormatted}
              />
            </Currency>
          )}
        </Column>
      )}
      <Column col={12} colSm={3}>
        <DeprecatedKeyMetric
          title="Total Return"
          size="large"
          metric={
            <>
              <PositiveNegativeValue value={totalDividendReturn / 100}>
                {totalDividendReturnFormatted}
              </PositiveNegativeValue>
            </>
          }
        />
        {!isWatchlist && (
          <Currency>
            <DeprecatedKeyMetric size="large" metric={totalGainFormatted} />
          </Currency>
        )}
      </Column>
    </ReturnsSummaryWrapper>
  </>
);

export default ReturnsSummary;
